import { isApiMockEnabled } from './isEnabled';
import { resolveMockResponse } from './handlers';

/**
 * Install an axios request interceptor that short-circuits with a mock adapter
 * when REACT_APP_API_MOCK=1 (development only).
 */
export function installAxiosMock(axiosInstance) {
    if (!axiosInstance || axiosInstance.__sparaMockInstalled) {
        return axiosInstance;
    }
    axiosInstance.__sparaMockInstalled = true;

    axiosInstance.interceptors.request.use((config) => {
        if (!isApiMockEnabled()) {
            return config;
        }
        const mock = resolveMockResponse(config);
        if (!mock) {
            return config;
        }
        config.adapter = async (cfg) => ({
            data: mock.data,
            status: mock.status || 200,
            statusText: mock.status >= 400 ? 'Error' : 'OK',
            headers: { 'content-type': 'application/json' },
            config: cfg,
            request: {},
        });
        return config;
    });

    return axiosInstance;
}
